import axios from '@/core/http'

const fetchSources = ({
  page,
  pageSize,
  ordering,
  query,
  empty,
  activeParsing,
  industry,
  category,
  country,
  region,
  district,
  city,
}) => {
  return axios
    .get('sources/', {
      params: {
        ['page']: page,
        ['page_size']: pageSize || 20,
        ['ordering']: ordering || undefined,
        ['active_parsing']: activeParsing || undefined,
        ['query']: query || undefined,
        ['empty']: empty || undefined,
        ['industry']: industry || undefined,
        ['category']: category || undefined,
        ['country']: country || undefined,
        ['region']: region || undefined,
        ['district']: district || undefined,
        ['city']: city || undefined,
      },
    })
    .then(res => res.data)
}

export { fetchSources }
